import { BoxxOAuthResponseProps } from './IBoxxOAuth';

export interface AppleOAuthResponse extends BoxxOAuthResponseProps {
  authResponse: {
    accessToken: string;
    idToken: string;
    refreshToken: string;
  };
  profileResponse: {
    email: string;
    firstName: string;
    lastName: string;
    imageUrl?: string;
  };
}
